import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './utils/http'
import utils from './utils/util'
// import './utils/InfoBox'




import 'animate.css';
import 'swiper/css/swiper.css'
import '@/scss/global.scss'

import './utils/rem'
import navBar from '@/components/navBar.vue'
import footer from '@/components/footer.vue'
import titleMenu from '@/components/titleMenu.vue'
import titleMenu2 from '@/components/titleMenu2.vue'
import dogTitle from '@/components/dogTitle.vue'
import titleCircle from '@/components/titleCircle.vue'
Vue.component('navBar', navBar)
Vue.component('pageFooter', footer)
Vue.component('titleMenu', titleMenu)
Vue.component('titleMenu2', titleMenu2)
Vue.component('dogTitle', dogTitle)
Vue.component('titleCircle', titleCircle)

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


Vue.prototype.$http = http
Vue.prototype.$utils = utils
Vue.prototype.isPhone = utils.IsPhone()
// import VConsole from 'vconsole';
// const vConsole = new VConsole();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
